import { createMediaButton } from "../create-media-button.js";
import { PlayButtonCore, PlayButtonDataAttrs } from "@videojs/core";
import { selectPlayback } from "@videojs/core/dom";
//#region src/ui/play-button/component.tsx
/**
* A button that toggles playback.
*
* @example
*   ```tsx
*   <PlayButton />
*
*   <PlayButton
*   render={(props, state) => (
*   <button {...props}>
*   {state.paused ? <PlayIcon /> : <PauseIcon />}
*   </button>
*   )}
*   />
*   ```;
*/
const PlayButton = createMediaButton({
	displayName: "PlayButton",
	core: PlayButtonCore,
	stateAttrMap: PlayButtonDataAttrs,
	selector: selectPlayback,
	action: (core, state) => core.toggle(state),
	hotkeyAction: "togglePaused"
});
//#endregion
export { PlayButton };

//# sourceMappingURL=component.js.map